// src/helpers/Global.js
const host = window.location.hostname;   // ej. "localhost" o "192.168.1.7"
const API_PORT = 5000;

export const Global = {
  url: "https://ticajewm.wemotion.es/api/",
  appName: "WeCronos",
  loginPrimary: "mail", // "mail" o "dni"
  rango_metros: 1000,
  partes_trabajo: "si",
  silcontrol: "no",
  mi_calendario: "si"
};
